import React from 'react';
import PropTypes from 'prop-types';

import AuthLayout from 'components/authentication/AuthLayout';
import EmailVerificationContent from 'components/authentication/EmailVerificationContent/index.js';


const EmailVerificationPage = ({ match }) => (
  <AuthLayout
    type="emailVerification"
    className="email-verification-page__component"
  >
    {match.params.key &&
      <EmailVerificationContent verificationKey={match.params.key} />
    }
  </AuthLayout>
);

EmailVerificationPage.propTypes = {
  match: PropTypes.object.isRequired,
};

export default EmailVerificationPage;
